<div class="flex-fill d-flex flex-column p-3">
    <div class="grid-fill">
        <dx-data-grid #dataGrid [dataSource]="users" keyExpr="id" (onCellDblClick)="rowDoubleClick($event)">
            <dxi-column dataField="userName" caption="Username" width="150"></dxi-column>
            <dxi-column dataField="firstName" caption="First Name" width="125"></dxi-column>
            <dxi-column dataField="lastName" caption="Last Name" width="125"></dxi-column>
            <dxi-column dataField="email" caption="Email" width="250"></dxi-column>
            <dxi-column dataField="active" caption="Active" width="100" trueText="Active" falseText="Inactive"></dxi-column>
            <dxi-column dataField="displayRoles" caption="Roles"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="user-search-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-sm btn-success me-2" (click)="open()">Add</button>
                <button class="btn btn-sm btn-primary" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                @if (users) {
                <span class="me-3">
                    <strong>{{ dataGrid.instance.totalCount() + " items" }}</strong>
                </span>
                }
            </div>
        </dx-data-grid>
    </div>
</div>
